import { LinkType } from '@ria-client/segment/enums';
import type { AnalyticsType } from '@ria-client/segment/types';
import { EntityPlacementCtaTypeEnum } from '@ria-client/supergraph/marketplace/enums';
import type { CtaType } from '@ria-client/supergraph/roundup/types';
import { TrackedLink } from '@ria-client/tw-shared-ui';

export interface CtaNameProps {
  cta?: CtaType;
  ctaAnalytics: AnalyticsType;
  displayName?: string;
}

export function CtaName({ cta, ctaAnalytics, displayName }: CtaNameProps) {
  if (!cta || !displayName) return null;

  return (
    <TrackedLink
      analyticsPayload={ctaAnalytics}
      cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductName }}
      className="font-sans text-base font-bold text-foreground no-underline hover:underline md:text-2xl"
      linkType={LinkType.PRODUCT_NAME}
      monetizable={ctaAnalytics.monetizable}
    >
      {displayName}
    </TrackedLink>
  );
}
